import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import { rootReducer } from './reducers';

export { firebaseApp } from './firebase';
export {
  fetchPollStateFb,
  createPollFb,
  deletePollFb,
  updatePollScoresFb,
  createFollowUpFb,
  listenForScores,
} from './dispatchers';

export { SET_BACKGROUND, SET_SCORE, RESULTS_VIEW_IS_BUBBLES } from './actions';

export interface IUser {
  id: string;
  currentScore: number;
}

export const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);
